import React from 'react';
import { College } from '../College';
import './colleges.css'

export const Colleges = ({header, text, onClick}) => {

  const styles = {
    container: {
      alignItems: 'center', // Center vertically
  
      padding: '10px',
      width: '100%',
      border:'none',
    
      cursor: 'pointer',
      backgroundColor: 'rgb(244, 235, 217)',
      
    },
    header: {
      fontSize:'22px',
      fontWeight:'500', 
      color: 'maroon',
      marginBottom: '10px',
    },
    text: {
      marginRight: '20px', // Optional spacing after the text
    },
   
    }

  return (
    <div>

          <div>
         
            <label style={styles.header}>{header}</label>
          
            <College university="University of Belgrade" country="Serbia" language="Serbian" progress="" active = {true} />
            <College university="University of Vienna" country="Austria" language="German" progress="(Coming soon)" active = {false}/> 
            <College university="University of Warsaw" country="Poland" language="Poish" progress= "(Coming soon)" active = {false}/>  
          </div>
    </div>
  );
};

